<template>
    <div class="container">
        <div class="give-me-space" id="login">
            <div class="d-flex align-items-center justify-center" style="margin-left: 0; margin-bottom: 5vw; height: 75vh;">
                <div v-if="!registration" style="display: flex; height: 100%; align-items: center;" class="col-12 col-sm-12 col-md-5">
                    <div class="w-100">
                        <a :href="$root.base_url">
                            <v-img style="margin-bottom: 40px; position: absolute; top:30px; left:30px" class="hover" max-width="150px" :src="$root.getSrc('default/drop/logo-drop.svg')" alt="Drop" />
                        </a>
                        <p class="mt-12" style="font-size: 40px; font-weight: 500">Sign in to Drop</p>
                        <p v-if="registration" style="color: #ff563d; font-size: 22px;">Please check your email now to validate your registration</p>
                        <div v-if="false" class="rwd-container-padding row w-100 mb-10" style="flex-wrap: wrap; justify-content: space-between; transform: translateX(17px);">
                            <div class="row">
                                <div class="col-6">
                                    <v-btn :href="$root.base_url+'/login/facebook'" class="popup-btn-resizer secondary-button login-icon-btn no-uppercase"><v-icon left >mdi-facebook</v-icon>Login with Facebook</v-btn>
                                </div>
                                <div class="col-6">
                                    <v-btn :href="$root.base_url+'/login/google'" class="popup-btn-resizer secondary-button login-icon-btn no-uppercase"><v-icon left >mdi-google</v-icon>Login with Google</v-btn>
                                </div>
                            </div>
                        </div>
                        <p style="color: red" v-if="shopifyError" class="ma-0">Shopify error: {{shopifyError}}</p>
                        <my-form  @submit.prevent="loginUser()" ref="form">
                            <v-text-field
                                class="login-text-field-customization mt-8"
                                outlined
                                dense
                                height="48"
                                color="new_blue_drop"
                                :error="(errors && errors.email)? true : false"
                                :error-messages="errors.email"
                                placeholder="Email"
                                type="text"
                                name="login"
                                v-model="user.email"
                                :rules="emailRules"
                                v-on:keyup.enter="loginUser"
                            ></v-text-field>

                            <v-text-field
                                class="login-text-field-customization"
                                outlined
                                :append-icon="passwordVisibility ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                                :type="passwordVisibility ? 'text' : 'password'"
                                dense
                                height="48"
                                color="new_blue_drop"
                                :error="(errors && errors.email)? true : false"
                                :error-messages="errors.password"
                                placeholder="Password"
                                v-model="user.password"
                                :rules="[validation.required]"
                                id="password"
                                @click:append="passwordVisibility = !passwordVisibility"
                                v-on:keyup.enter="loginUser"
                            ></v-text-field>
                            <!--<router-link to="/forget" style="font-size: 0.8rem; text-decoration: none;">{{$t('Forget password?')}}</router-link>-->
                            <!--<router-link to="/resend" style="font-size: 0.8rem; text-decoration: none;">{{$t('Resend verification email')}}</router-link>-->
                            <div style="transform: translateY(-25px)">
                                <div class="d-flex justify-space-between align-center">
                                    <v-checkbox class="login-checkbox" color="new_blue_drop" :label="'Remember me'"></v-checkbox>
                                    <router-link to="/forget" class="mb-1 fw-500 p-0" style="text-decoration:none; color: black; opacity: .85; height: fit-content; font-size: 14px">{{$t('Forget password?')}}</router-link>
                                </div>
                                <v-card-actions height="50%" class="pl-0 pr-0" style="display: flex; justify-content: space-between;">
                                    <!--<secondary-button :goToHref="goToRegister" :loading="loading"  :activeButton="true">{{$t("Sign up")}}</secondary-button>-->
                                    <primary-button @clickBtn="loginUser" color="new_blue_drop" :loading="loading"  class="w-100" :activeButton="true">{{$t("Sign in")}}</primary-button>
                                </v-card-actions>
                                <div class="fw-400 fs-18 text-center mt-1">Do you have an account? <router-link :to="getRegister" style="color: #4353FF; text-decoration: none">SIGN UP</router-link></div>
                                <a v-if="false" @click="resendVerificationEmail" style="font-size: 0.8rem; text-decoration: none;">Resend verification email</a>
                            </div>
                        </my-form>
                    </div>
                </div>
                <div v-else>
                    <p style="color: black; font-weight: 500; font-size: 52px; display: inline-block;">Almost there!</p>
                    <p style="font-size: 36px; color: black; font-weight: normal;  font-family: 'open-sans', serif;">Please check your email now to validate your registration</p>
                </div>
                <div class="col-md-7 login-auth-pic">
                    <AuthPic></AuthPic>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
    import {required, email} from "../../validations";
    import {setToken} from "../../utilis/auth";
    import {resendConfirmation} from "@/api/user";
    import AuthPic from '@/components/auth-pic.vue'
    import store from "@/store";
    import {getIntegrationsFromCookies} from "../../utilis/integration_cookies";
    import Cookies from "js-cookie";

    export default {
        components: { AuthPic },
        data(){
            return{
                passwordVisibility: false,
                user:{},
                errors:[],
                loading: false,
                validation:{required, email},
                resendEmail:false,
                registration: false,
                emailRules: [],
                shopifyError: null
            }
        },
        mounted(){
            if(this.$route.query.token){
                setToken(this.$route.query.token);
                this.$store.dispatch('websites/getWebsites');
                this.$router.push('/');
            }
            if(this.$route.query.verification && this.$route.query.verification.length>0) this.registration = true;
            if(this.$route.query.account_deleted && this.$route.query.account_deleted.length>0) this.$store.commit('app/ADD_MESSAGE', {text:this.$t('Account successfully deleted.'), type: 'info'});
            if(this.$route.query.utm_source) this.$set(this.user,'utm_source', this.$route.query.utm_source);
        },
        computed:{
            logo(){
                return this.$store.getters.logo;
            },
            goToRegister(){
                return this.$route.query.utm_source ? '/app/register' + '?utm_source=' + this.$route.query.utm_source : '/app/register';
            },
            getRegister(){
                if(this.$route.query.utm_source) return '/register' + '?utm_source=' + this.$route.query.utm_source
                if(this.$route.query.api_key && this.$route.query.domain) return '/register' + '?api_key=' +this.$route.query.api_key+'&domain='+this.$route.query.domain;
                return '/register';
            }
        },
        methods: {
            changePasswordVisibility(){
                this.passwordVisibility = !this.passwordVisibility
            },
            loginUser(){
                this.emailRules = [this.validation.required, this.validation.email];
                if(this.$refs.form.my_validate()){
                    this.shopifyError = null;
                    this.loading = true;
                    this.startLoading();
                    if(this.$route.query.api_key && this.$route.query.domain){
                        this.$set(this.user,'api_key', this.$route.query.api_key);
                        this.$set(this.user,'domain', this.$route.query.domain);
                    }
                    this.$store.dispatch('user/login', this.user).then(response => {
                        if(this.$route.query.api_key && this.$route.query.domain){
                            setTimeout(() => {
                                this.$router.push({ path: '/integration'});
                                return null;
                            }, 100)
                        }
                        if(this.$store.getters.user.user_websites.length > 0 || this.$store.getters.user.website_permissions.length>0){
                            this.$router.push({ path: this.redirect || '/', query:this.$route.query});
                        } else {
                            this.$router.push({ path: this.redirect || '/user/edit', query:this.$route.query });
                        }
                        this.stopLoading();
                        this.loading = false;
                    }).catch(e => {
                        this.stopLoading();
                        this.errors = e.response.data.errors;
                        if(this.errors.email){
                            this.resendEmail = true;
                        } else {
                            this.resendEmail = false;
                        }
                        if(this.errors.shopify){
                            this.shopifyError = this.errors.shopify;
                        }
                        this.loading = false;
                        setTimeout(() => {
                            this.errors = [];
                        }, 3000)
                    })
                }
            },
            resendVerificationEmail(){
                resendConfirmation({email: this.user.email}).then(res => {
                    this.resended = true;
                    this.loading = false;
                    this.$store.commit('app/ADD_MESSAGE', {text:this.$t('We sent verification email.'), type: 'success'});
                })
            },
        }
    }
</script>
<style scoped lang="css">
.primary-button {
    background: #2F80ED;
    border: 2px solid  #2F80ED;
    color: #fff;
}
.secondary-button {
    border: 2px solid #2F80ED;
    color: #fff;
    background-color: #fff !important;
}

</style>
